import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PecasSolicitadasService } from '../pecas-solicitadas-service/pecas-solicitadas.service';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { EstruturaGridViewBuilder } from './../../../../shared/gridview/EstruturaGridViewBuilder';

@Component({
  selector: 'app-pecas-solicitadas-lista',
  templateUrl: '../../template/lista.html',
  styleUrls: ['./pecas-solicitadas-lista.component.css']
})
export class PecasSolicitadasListaComponent
  extends ListaBase
  implements OnInit {
  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;

  constructor(service: PecasSolicitadasService, toastr: ToastrService, router: Router) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = true;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 10;
    this.exibirBotaoDetalhes = true;
  }

  ngOnInit() {
    this.buscar();
    this.estrutura = new EstruturaGridViewBuilder()
      .addColuna("nome_dealer", 'Dealer')
      .addColuna("ano", 'parametros.pecaSolicitada.ano')
      .addColuna("mes", 'parametros.pecaSolicitada.mes')
      .addColuna("valor", 'parametros.pecaSolicitada.quantidade')
      .build();
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.id
      || this.filtros.id_dealer
      || this.filtros.valor
      || this.filtros.mes
      || this.filtros.ano;
  }

}
